"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Alert = _interopRequireDefault(require("./svgs/Alert"));

var _ArrowLeft = _interopRequireDefault(require("./svgs/ArrowLeft"));

var _ArrowRight = _interopRequireDefault(require("./svgs/ArrowRight"));

var _Belt = _interopRequireDefault(require("./svgs/Belt"));

var _Box = _interopRequireDefault(require("./svgs/Box"));

var _Calendar = _interopRequireDefault(require("./svgs/Calendar"));

var _Camera = _interopRequireDefault(require("./svgs/Camera"));

var _Cart = _interopRequireDefault(require("./svgs/Cart"));

var _Check = _interopRequireDefault(require("./svgs/Check"));

var _Cufflinks = _interopRequireDefault(require("./svgs/Cufflinks"));

var _Email = _interopRequireDefault(require("./svgs/Email"));

var _EmptyLook = _interopRequireDefault(require("./svgs/EmptyLook"));

var _Facebook = _interopRequireDefault(require("./svgs/Facebook"));

var _Gt = _interopRequireDefault(require("./svgs/Gt726"));

var _Hanger = _interopRequireDefault(require("./svgs/Hanger"));

var _Instagram = _interopRequireDefault(require("./svgs/Instagram"));

var _Jacket = _interopRequireDefault(require("./svgs/Jacket"));

var _LapelPin = _interopRequireDefault(require("./svgs/LapelPin"));

var _Lock = _interopRequireDefault(require("./svgs/Lock"));

var _LogoGentux = _interopRequireDefault(require("./svgs/LogoGentux"));

var _LogoGentuxWordmark = _interopRequireDefault(require("./svgs/LogoGentuxWordmark"));

var _LogoMenguin = _interopRequireDefault(require("./svgs/LogoMenguin"));

var _LogoMenguinWordmark = _interopRequireDefault(require("./svgs/LogoMenguinWordmark"));

var _Message = _interopRequireDefault(require("./svgs/Message"));

var _No = _interopRequireDefault(require("./svgs/No"));

var _NotRenting = _interopRequireDefault(require("./svgs/NotRenting"));

var _Pants = _interopRequireDefault(require("./svgs/Pants"));

var _PartnerProgram = _interopRequireDefault(require("./svgs/PartnerProgram"));

var _Pencil = _interopRequireDefault(require("./svgs/Pencil"));

var _Person = _interopRequireDefault(require("./svgs/Person"));

var _Phone = _interopRequireDefault(require("./svgs/Phone"));

var _Pinterest = _interopRequireDefault(require("./svgs/Pinterest"));

var _Plus = _interopRequireDefault(require("./svgs/Plus"));

var _PocketSquare = _interopRequireDefault(require("./svgs/PocketSquare"));

var _Shirt = _interopRequireDefault(require("./svgs/Shirt"));

var _Shoe = _interopRequireDefault(require("./svgs/Shoe"));

var _Socks = _interopRequireDefault(require("./svgs/Socks"));

var _Star = _interopRequireDefault(require("./svgs/Star"));

var _StarHalf = _interopRequireDefault(require("./svgs/StarHalf"));

var _Stopwatch = _interopRequireDefault(require("./svgs/Stopwatch"));

var _Swatch = _interopRequireDefault(require("./svgs/Swatch"));

var _Tie = _interopRequireDefault(require("./svgs/Tie"));

var _Trashcan = _interopRequireDefault(require("./svgs/Trashcan"));

var _TriangleDown = _interopRequireDefault(require("./svgs/TriangleDown"));

var _TriangleLeft = _interopRequireDefault(require("./svgs/TriangleLeft"));

var _TriangleRight = _interopRequireDefault(require("./svgs/TriangleRight"));

var _TriangleUp = _interopRequireDefault(require("./svgs/TriangleUp"));

var _Truck = _interopRequireDefault(require("./svgs/Truck"));

var _Twitter = _interopRequireDefault(require("./svgs/Twitter"));

var _Vest = _interopRequireDefault(require("./svgs/Vest"));

var _X = _interopRequireDefault(require("./svgs/X"));

var _Undo = _interopRequireDefault(require("./svgs/Undo"));

var _Redo = _interopRequireDefault(require("./svgs/Redo"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var _default = {
  Alert: _Alert.default,
  ArrowLeft: _ArrowLeft.default,
  ArrowRight: _ArrowRight.default,
  Belt: _Belt.default,
  Box: _Box.default,
  Calendar: _Calendar.default,
  Camera: _Camera.default,
  Cart: _Cart.default,
  Check: _Check.default,
  Cufflinks: _Cufflinks.default,
  Email: _Email.default,
  EmptyLook: _EmptyLook.default,
  Facebook: _Facebook.default,
  Gt726: _Gt.default,
  Hanger: _Hanger.default,
  Instagram: _Instagram.default,
  Jacket: _Jacket.default,
  LapelPin: _LapelPin.default,
  Lock: _Lock.default,
  LogoGentux: _LogoGentux.default,
  LogoGentuxWordmark: _LogoGentuxWordmark.default,
  LogoMenguin: _LogoMenguin.default,
  LogoMenguinWordmark: _LogoMenguinWordmark.default,
  Message: _Message.default,
  No: _No.default,
  NotRenting: _NotRenting.default,
  Pants: _Pants.default,
  PartnerProgram: _PartnerProgram.default,
  Pencil: _Pencil.default,
  Person: _Person.default,
  Phone: _Phone.default,
  Pinterest: _Pinterest.default,
  Plus: _Plus.default,
  PocketSquare: _PocketSquare.default,
  Shirt: _Shirt.default,
  Shoe: _Shoe.default,
  Socks: _Socks.default,
  Star: _Star.default,
  StarHalf: _StarHalf.default,
  Stopwatch: _Stopwatch.default,
  Swatch: _Swatch.default,
  Tie: _Tie.default,
  Trashcan: _Trashcan.default,
  TriangleDown: _TriangleDown.default,
  TriangleLeft: _TriangleLeft.default,
  TriangleRight: _TriangleRight.default,
  TriangleUp: _TriangleUp.default,
  Truck: _Truck.default,
  Twitter: _Twitter.default,
  Vest: _Vest.default,
  X: _X.default,
  Undo: _Undo.default,
  Redo: _Redo.default
};
exports.default = _default;